import React from "react";

import instaglam from "../../assets/instaglam.png";
import chat from "../../assets/chat.png";
import reward from "../../assets/instantReward.jpg";

const Slider = () => {
  return (
    <>
    <h2 className="checkHeading" style={{ fontSize: '16px',
                 fontStyle: 'normal',
                 fontWeight: '600',
                 lineHeight: '24px',
                 margin: '30px 30px 20px 30px',
                 color: '#666'

     }}>While you wait also Check...</h2>
    <div
      className="slider_cards_wrapper"
      style={{ display: "flex", gap: "1rem",marginTop: '20px'}}
    >
      <div className="slider_card">
        <a href="https://www.instagram.com/aqualens.in/?hl=en">
          <div className="imageWrapper">
            <img src={instaglam} alt="" />
          </div>
        </a>
      </div>
      <div className="slider_card">
        <a href="https://aqualens.in/pages/contact-us">
          <div className="imageWrapper">
            <img src={chat} alt="" />
          </div>
        </a>
      </div>
       {/*<div className="slider_card">
        <a href="https://www.instagram.com/aqualens.in/?hl=en">
          <div className="imageWrapper">
            <img src={reward} alt="" />
          </div>
        </a>
      </div> */}
    </div>
    </>
  );
};

export default Slider;
